import { Link } from "react-router-dom";
import { BRAND, LEGAL_NOTICE } from "@/config";

const COLS = [
  {
    title: "Explore",
    links: [
      { label: "Shop", to: "/shop" },
      { label: "Research", to: "/shop?category=Research%20Peptides" },
      { label: "Bundles", to: "/bundles" },
      { label: "New Arrivals", to: "/shop?category=New%20Arrivals" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Transparency", to: "/about" },
      { label: "Community", to: "/community" },
      { label: "FAQ", to: "/about" },
      { label: "Contact", to: "/about" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Shipping", to: "/about" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="relative border-t border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid gap-10 md:grid-cols-5">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center">
              <span className="font-wordmark text-2xl leading-none tracking-tight text-slate-900">PEPSWORLD UK.</span>
            </Link>
            <p className="mt-3 font-mono2 text-xs uppercase tracking-[0.3em] text-slate-500">{BRAND.slogan}</p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-600">
              A modern UK research-focused brand built around precision, transparency and quality.
            </p>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-mono2 text-xs uppercase tracking-widest text-slate-500">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-slate-600 hover:text-slate-900 transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-xl border border-amber-300 bg-amber-50 p-4">
          <p className="text-xs leading-relaxed text-amber-900">
            <span className="font-semibold">Research & Educational Use Only — </span>
            {LEGAL_NOTICE}
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-slate-200 pt-6 sm:flex-row">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <p className="font-mono2 text-xs tracking-wider text-slate-500">United Kingdom · Built for precision</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
